import * as angular from "angular";
import {IController, IQService, ITimeoutService, IWindowService} from "angular";
import * as _ from "lodash";
import {AgentDialogService} from "../../services/agent-dialogs-service.service";
import {AgentsAlerts} from "../../services/agents-alerts.service";
import {AgentModel} from "../../angular/models/agent.model";
import {LogisticsVehicle} from "../../../logistics-vehicle/models/logistics-vehicle.model";
import {AnalyticsService} from "../../../commons/services/analytics-service.service";
import {ItinerariesTasksSettings} from "../../angular/models/itineraries-tasks-settings.model";
import {$agentFactory} from "../../$agent.factory";
import {BringozApi} from "../../../persistence-layer/models/bringoz-api.model";
import {SplitService} from "../../../commons/services/split-service.service";
import {TasksService} from "../../../tasks/services/tasks-service.service";
import {DeliveriesAlertsService} from "../../../deliveries/services/deliveries-alerts.service";
import {LeanPlanningDialogService} from "../../../lean-planning/services/lean-planning-dialogs-service.factory";
import {TaskModel} from "../../../tasks/models/task.model";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {LeanPlanningService} from "../../../lean-planning/services/lean-planning-service.service";

export class AgentItineraryTasksCtrl implements IController {

  agent: AgentModel;
  agentConfigurationProfile: any;
  attachedLogisticsVehicles: LogisticsVehicle[];
  tasks: any;
  highlightedServiceId: any;
  isBundleView: any;
  editModeDisabled: any;
  selectedTab: any; //TODO Move up all actions and remove this!
  inActiveTasksDate: any; //TODO Move up all actions and remove this!
  isExpandedTasks: any;
  isExpendedTable: boolean;

  onInactiveDateChange: Function;
  onHighlightedChanged: Function;
  toggleEditMode: Function;
  onGetAnalysis: Function;
  onSettings: Function;
  onUnbindVehicle: Function;
  onReset: Function;
  onToggleTasksExpanded: Function;
  onExpandTable: Function;

  public itinerariesTaskSettings: ItinerariesTasksSettings;
  private loading: boolean;
  private queryString: string;
  private tasksRef: any;
  private maxDate: any;
  private selectedTaskIds: any;

  private disableClearAndCompleteActions: any;
  private disablePickupSelection: any;
  private disableDropoffSelection: any;
  private disableOperationSelection: any;
  private siteId: string;
  public filteredTasks: TaskModel[];
  public isDisableEntityStateLock: boolean;

  constructor(private $task, private $log, private tasksAPI: BringozApi, private $timeout: ITimeoutService, private $agent: $agentFactory, private AgentsAPI: BringozApi,
              private $state, private splitService: SplitService, private agentsAlerts: AgentsAlerts, private $window: IWindowService, private agentDialogService: AgentDialogService,
              private deliveriesAlertsService: DeliveriesAlertsService, private analyticsService: AnalyticsService, private moment, private $q: IQService,
              private leanPlanningService: LeanPlanningService,
              private leanPlanningDialogService: LeanPlanningDialogService, private tasksService: TasksService, private commonsService: CommonsService) {
  }

  $onInit() {
    this.tasksRef = this.$task();
    this.maxDate = this.moment().toDate();
    this.selectedTaskIds = [];

    this.siteId = this.splitService.getSiteId();
    this.itinerariesTaskSettings = this.splitService.getSiteItinerariesTasksSettings(this.siteId);
    this.isDisableEntityStateLock = this.splitService.getDisableEntityLockStateValue();
  }

  $onChanges(changes) {
    if (changes.agent && !changes.agent.isFirstChange()) {
      const currentAgent = changes.agent.currentValue;
      const previousAgent = changes.agent.previousValue;


      if (currentAgent.id !== previousAgent.id) {
        this.selectedTaskIds = [];
      }
      if (currentAgent && currentAgent.updatedAt > previousAgent.updatedAt) {
        this.onGetAnalysis();
      }
    }

    if (changes.tasks) {
      this.filteredTasks = angular.copy(this.tasks);

      this.$timeout(() => {
      }, 0);

    }
  };

  onToggleEditMode() {
    this.analyticsService.trackEvent('Agents Actions', 'Edit Itinerary', 'Click');
    this.toggleEditMode();
  }

  onSwapDeliveries(event) {
    this.analyticsService.trackEvent('Agents Actions', 'Swap Services', 'Click');
    this.agentDialogService.swapDeliveries(this.agent, event)
      .then((deliveryIdsMoved) => {

      })
      .catch((error) => {
        if (error) {
          this.analyticsService.trackEvent('Agents Actions', 'Swap Services', 'Error');
          this.$log.error(error.message);
        } else {
          this.$log.info('Dialog Closed');
        }
      });
  }

  onSwapRoutes(event) {
    this.analyticsService.trackEvent('Agents Actions', 'Swap Routes', 'Click');
    this.agentDialogService.swapRoutes([this.agent.id], event)
      .then((payload) => {
        this._assignRoutesToAgent(payload.routeIds, payload.agentId, payload.assignAllServicesToAgent);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      });
  }

  onPrintItinerary() {
    this.analyticsService.trackEvent('Agents Actions', 'Print Itinerary', 'Click');

    const siteId = this.splitService.getSiteId();
    const url = this.$state.href('print.itinerary', {agentId: this.agent.id, siteId: siteId});
    this.$window.open(url, '_blank', 'width=900,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no')
  }

  onPrintPackages() {
    this.analyticsService.trackEvent('Agents Actions', 'Print Packages', 'Click');

    const siteId = this.splitService.getSiteId();
    const url = this.$state.href('print.packages', {agentId: this.agent.id, siteId: siteId});
    this.$window.open(url, '_blank', 'width=900,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no')
  }

  onRefreshItinerary(event) {
    this._refreshItinerary();
    this.$timeout(0).then(() => {
    });
  }

  onReoptimizeItinerary(event) {
    const hasPinnedTasked = _.find(this.tasks, (t) => {
      return _.get(t, 'analysis.pinned', false);
    })
    const refFunction = hasPinnedTasked ? this.agentDialogService.reoptimizeItineraryWithPinnedTasks(event) : this.$q.when(false);
    refFunction
      .then((shouldUnpin) => {
        if (shouldUnpin) this.onReset();
        else this._reoptimizeItinerary();
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onSettingsClick() {
    this.analyticsService.trackEvent('Agents Actions', 'Itinerary Settings', 'Click');
    this.onSettings();
  }

  onLoading(isLoading) {
    this.loading = isLoading;
  }

  initTasksActionMenu($mdMenu, event) {
    this.disableClearAndCompleteActions = _.isEmpty(this.selectedTaskIds);
    this.disablePickupSelection = _.isUndefined(_.find(this.tasks, (t) => {
      return t.taskSpec.purpose === 'Pickup' && !_.isEqual(t.analysis.state, 'UnstartableDependent');
    }));
    this.disableDropoffSelection = _.isEmpty(this.tasks) || _.isUndefined(_.find(this.tasks, (t) => {
      return t.taskSpec.purpose === 'Dropoff' && !_.isEqual(t.analysis.state, 'UnstartableDependent');
    }));
    this.disableOperationSelection = _.isEmpty(this.tasks) || _.isUndefined(_.find(this.tasks, (t) => {
      return t.taskSpec.purpose === 'Operation' && !_.isEqual(t.analysis.state, 'UnstartableDependent');
    }));

    $mdMenu.open(event);
  }

  selectAllPickups() {
    this.clearAllSelectedTasks();

    const selectedTaskIdsCopy = angular.copy(this.selectedTaskIds);
    _.forEach(this.tasks, (t) => {
      if (_.isEqual(t.taskSpec.purpose, 'Pickup')) {
        selectedTaskIdsCopy.push(t.id);
      }
    });

    this.selectedTaskIds = selectedTaskIdsCopy;
  }

  selectAllDropoffs() {
    this.clearAllSelectedTasks();

    const selectedTaskIdsCopy = angular.copy(this.selectedTaskIds);
    _.forEach(this.tasks, (t) => {
      if (_.isEqual(t.taskSpec.purpose, 'Dropoff') && (!_.isEqual(t.analysis.state, 'UnstartableDependent'))) {
        selectedTaskIdsCopy.push(t.id);
      }
    });
    this.selectedTaskIds = selectedTaskIdsCopy;
  }

  selectAllOperations() {
    this.clearAllSelectedTasks();

    const selectedTaskIdsCopy = angular.copy(this.selectedTaskIds);
    _.forEach(this.tasks, (t) => {
      if (_.isEqual(t.taskSpec.purpose, 'Operation')) {
        selectedTaskIdsCopy.push(t.id);
      }
    });

    this.selectedTaskIds = selectedTaskIdsCopy;
  }

  clearAllSelectedTasks() {
    this.selectedTaskIds = [];
  }

  doCompleteSelectedTasks() {
    if (!_.isEmpty(this.selectedTaskIds)) {
      this.loading = true;
      this.analyticsService.trackEvent('Agents Actions', 'Complete Selected Itinerary Tasks', 'Click');
      this.tasksRef.$call(this.tasksAPI.actions.complete, {ids: this.selectedTaskIds})
        .then(() => {
          if (this.selectedTaskIds.length > 1) {
            this.deliveriesAlertsService.completeTasksSuccess();
          } else {
            this.deliveriesAlertsService.completeTaskSuccess();
          }
          this.selectedTaskIds = [];
        })
        .catch((error) => {
          this.analyticsService.trackEvent('Agents Actions', 'Complete Selected Itinerary Tasks', 'Error');
          this.deliveriesAlertsService.completeTasksError();
          this.$log.error('Failed to complete itinerary selected tasks, ' +
            'agentItineraryActiveSection@doCompleteSelectedTasks', error);
        })
        .finally(() => {
          this.loading = false;
        })
    }
  }

  searchQuery(query) {
    this.queryString = query || undefined;

    if (!!this.queryString) {
      this.filteredTasks = angular.copy(this.commonsService.findInObjArray(angular.copy(this.tasks), this.queryString));
    } else {
      this.filteredTasks = angular.copy(this.tasks)
    }

    this.$timeout(() => {
    }, 0);
  }

  onTaskSelectToggle(taskId) {
    let selectedTaskIndex = _.indexOf(this.selectedTaskIds, taskId);
    const selectedTaskIdsCopy = angular.copy(this.selectedTaskIds);

    if (_.isEqual(selectedTaskIndex, -1)) {
      selectedTaskIdsCopy.push(taskId)
    } else {
      selectedTaskIdsCopy.splice(selectedTaskIndex, 1)
    }
    this.selectedTaskIds = selectedTaskIdsCopy;
  }

  onEditTaskBoundEquipment(task, event) {
    this.leanPlanningDialogService.onEditTaskBoundEquipment(task, _.get(this.agent, 'branchIds'), event)
      .then((task: TaskModel) => {
        this.tasksService.updateInternalTask(task)
      })
      .catch((error) => {
        this.$log.info('Dialog Closed', error)
      })
  }

  // ******************************
  //        Public methods
  // ******************************

  onViewSettingsChange(settings) {
    this.itinerariesTaskSettings = angular.copy(settings);
    this.splitService.setSiteItinerariesTasksSettings(settings);
  }

  layoutDone() {
    this.$timeout(500).then(() => {
      this.loading = false;
    })
  }

  // ******************************
  //        Private methods
  // ******************************

  private _refreshItinerary() {
    this.loading = true;
    this.analyticsService.trackEvent('Agents Actions', 'Refresh Itinerary', 'Click');
    this.$agent(this.agent.id).$call(this.AgentsAPI.actions.refresh)
      .then((refreshData) => {
        // ctrl.onRefresh({refreshData: refreshData});
        this.agentsAlerts.updateItinerarySuccess();
      })
      .catch((error) => {
        this.agentsAlerts.updateItineraryError();
        this.$log.error('Could not refresh Itinerary, agentItinerarySection@refreshAgentItinerary', error);
        this.analyticsService.trackEvent('Agents Actions', 'Refresh Itinerary', 'Error');
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private _reoptimizeItinerary() {
    this.loading = true;
    this.analyticsService.trackEvent('Agents Actions', 'Re-optimize Itinerary', 'Click');
    this.$agent(this.agent.id).$call(this.AgentsAPI.actions.recalc)
      .then((refreshData) => {
        // ctrl.onRefresh({refreshData: refreshData});
        this.agentsAlerts.updateItinerarySuccess();
      })
      .catch((error) => {
        this.agentsAlerts.updateItineraryError();
        this.$log.error('Could not re-optimize Itinerary, agentItinerarySection@reoptimizeItinerary', error);
        this.analyticsService.trackEvent('Agents Actions', 'Re-optimize Itinerary', 'Error');
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private _assignRoutesToAgent(routeIds: string[], agentId: string, assignAllServicesToAgent?: boolean) {
    this.leanPlanningService.assignRoutesToAgent(routeIds, agentId, assignAllServicesToAgent)
      .catch((error) => {
        if (error) {
          this.analyticsService.trackEvent('Agents Actions', 'Swap Routes', 'Error');
        }
      });
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentItineraryTasks', {
    bindings: {
      agent: '<',
      agentConfigurationProfile: '<',
      attachedLogisticsVehicles: '<?',
      tasks: '<',
      highlightedServiceId: '<',
      isBundleView: '<',
      editModeDisabled: '<',
      selectedTab: '<', //TODO Move up all actions and remove this!
      inActiveTasksDate: '<', //TODO Move up all actions and remove this!
      isExpandedTasks: '<',
      isExpendedTable: '<',
      onInactiveDateChange: '&',
      onHighlightedChanged: '&',
      toggleEditMode: '&',
      onGetAnalysis: '&',
      onSettings: '&',
      onReset: '&',
      onUnbindVehicle: '&',
      onExpandTable: '&',
      onToggleTasksExpanded: '&',
      onToggleMap: '&',
    },
    template: require('./agent-itinerary-tasks.html').default,
    controller: AgentItineraryTasksCtrl
  });
